var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImplementation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#4196c8",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.82,53.45h-18c-6.41,0-11.62-5.21-11.62-11.62s5.21-11.62,11.62-11.62h18c6.41,0,11.62,5.21,11.62,11.62s-5.21,11.62-11.62,11.62Zm-18-22c-5.72,0-10.38,4.65-10.38,10.38s4.65,10.38,10.38,10.38h18c5.72,0,10.38-4.65,10.38-10.38s-4.65-10.38-10.38-10.38h-18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.82,83.45h-18c-6.41,0-11.62-5.21-11.62-11.62s5.21-11.62,11.62-11.62h18c6.41,0,11.62,5.21,11.62,11.62s-5.21,11.62-11.62,11.62Zm-18-22c-5.72,0-10.38,4.65-10.38,10.38s4.65,10.38,10.38,10.38h18c5.72,0,10.38-4.65,10.38-10.38s-4.65-10.38-10.38-10.38h-18Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.82,49.45c-4.2,0-7.62-3.42-7.62-7.62s3.42-7.62,7.62-7.62,7.62,3.42,7.62,7.62-3.42,7.62-7.62,7.62Zm0-14c-3.52,0-6.38,2.86-6.38,6.38s2.86,6.38,6.38,6.38,6.38-2.86,6.38-6.38-2.86-6.38-6.38-6.38Z",
    fill: "#dedede",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.82,79.45c-4.2,0-7.62-3.42-7.62-7.62s3.42-7.62,7.62-7.62,7.62,3.42,7.62,7.62-3.42,7.62-7.62,7.62Zm0-14c-3.52,0-6.38,2.86-6.38,6.38s2.86,6.38,6.38,6.38,6.38-2.86,6.38-6.38-2.86-6.38-6.38-6.38Z",
    fill: "#dedede",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplementation);
export default __webpack_public_path__ + "static/media/implementation.0169d4dcc1619d9edf4d514e54a1d6b7.svg";
export { ForwardRef as ReactComponent };